import React, { useCallback, useMemo, useState } from "react";
import TableContext, { TableContextValues } from "../../task/TableContext";
import {
  applyFiltersHelper,
  setCurrentPageHelper,
  setPageSizeHelper,
  sortHelper,
  useEndpointData
} from "../../../utils/TableUtils";
import PortalClientService, {
  PortalClientDataRequest
} from "../../../services/PortalClientService";
import { TranslationService } from "../../../services/TranslationService";

export class PortalClientTableContextValues extends TableContextValues<any> {
  request: PortalClientDataRequest = new PortalClientDataRequest();
  setRequest: (request: PortalClientDataRequest) => void = () => {};
}

const procesarArray = (array: any[]): any[] => {
  const arrCopied = [...array];
  const objDue = arrCopied.find((item) => item.Key === "-5");
  const dueDays = arrCopied.find((item) => item.Key === "dueDays");
  const filteredArray = arrCopied.filter(
    (item) => item.Key !== "-5" && item.Key !== "dueDays"
  );

  if (objDue) {
    filteredArray.push({
      Key: "-5",
      Value: objDue.Value,
      dueDays: dueDays ?? null
    });
  }

  return filteredArray;
};

const responseFormated = (result: any) => {
  const { data, ...rest } = result;
  const formattedRows = data.rowsToShow.map(procesarArray);

  return {
    ...rest,
    data: {
      ...data,
      rowsToShow: formattedRows
    }
  };
};

const PortalClientTableProvider = ({
  token,
  children
}: React.PropsWithChildren<{ token: string }>) => {
  const language = TranslationService.currentLanguage;
  const [request, setRequest] = useState(new PortalClientDataRequest());
  const endpoint = useCallback(
    () => PortalClientService.getIoList(request, token, language),
    [request, token, language]
  );
  const { loading, error, response, reload } = useEndpointData<any>(endpoint);
  const { sort, setSortColumn } = sortHelper(request, setRequest);
  const pageCount = useMemo(
    () =>
      response?.data
        ? Math.ceil(response.data.count / response.data.pagesize)
        : 0,
    [response?.data]
  );

  const value: PortalClientTableContextValues = {
    loading,
    error,
    response: response ? responseFormated(response) : undefined,
    setSortColumn,
    currentPage: request.page,
    setCurrentPage: response?.data
      ? setCurrentPageHelper(setRequest, response.data.count)
      : () => {},
    pageCount,
    applyFilters: applyFiltersHelper(setRequest),
    applySearch: (keyword: any) => {
      setRequest({ ...request, filter: keyword });
    },
    reload,
    sort,
    pageSize: request.pagesize,
    setPageSize: setPageSizeHelper(setRequest),
    request,
    setRequest
  };

  return (
    <TableContext.Provider value={value}>{children}</TableContext.Provider>
  );
};

export default PortalClientTableProvider;
